export const SET_CHART_PROPERTIES = 'SET_CHART_PROPERTIES';
export const SET_SELECTED_PROPERTIES = 'SET_SELECTED_PROPERTIES';
export const SET_TITLE = 'SET_TITLE';
export const SET_IS_LOADING = 'SET_IS_LOADING';
export const SET_ADAPTER_RESULT = 'SET_ADAPTER_RESULT';
export const SET_IS_LONG_POLLING = 'SET_IS_LONG_POLLING';
export const SET_IS_INITIAL_CALL = 'SET_IS_INITIAL_CALL';
export const SET_ADT_HIERARCHY_NODES = 'SET_ADT_HIERARCHY_NODES';
export const SET_ADT_HIERARCHY_NODE_PROPERTIES =
    'SET_ADT_HIERARCHY_NODE_PROPERTIES';
export const SET_ADT_HIERARCHY_SELECTED_TWIN_ID =
    'SET_ADT_HIERARCHY_SELECTED_TWIN_ID';
export const SET_ADT_HIERARCHY_SEARCH = 'SET_ADT_HIERARCHY_SEARCH';
export const SET_TWIN_LOOKUP_STATUS = 'SET_TWIN_LOOKUP_STATUS';
export const SET_ADT_SCENE_BUILDER_ELEMENTS = 'SET_ADT_SCENE_BUILDER_ELEMENTS';
export const SET_ADT_SCENE_BUILDER_BEHAVIORS =
    'SET_ADT_SCENE_BUILDER_BEHAVIORS';
export const SET_ADT_SCENE_BUILDER_SELECTED_ELEMENT =
    'SET_ADT_SCENE_BUILDER_SELECTED_ELEMENT';
export const SET_ADT_SCENE_ELEMENT_SELECTED_OBJECT_IDS =
    'SET_ADT_SCENE_ELEMENT_SELECTED_OBJECT_IDS';
export const SET_ADT_SCENE_BUILDER_MODE = 'SET_ADT_SCENE_BUILDER_MODE';

export const SET_OAT_PROPERTY_EDITOR_CURRENT_PROPERTY_INDEX =
    'SET_OAT_PROPERTY_EDITOR_CURRENT_PROPERTY_INDEX';
export const SET_OAT_PROPERTY_EDITOR_CURRENT_NESTED_PROPERTY_INDEX =
    'SET_OAT_PROPERTY_EDITOR_CURRENT_NESTED_PROPERTY_INDEX';
export const SET_OAT_PROPERTY_EDITOR_DRAGGING_TEMPLATE =
    'SET_OAT_PROPERTY_EDITOR_DRAGGING_TEMPLATE';
export const SET_OAT_PROPERTY_EDITOR_DRAGGING_PROPERTY =
    'SET_OAT_PROPERTY_EDITOR_DRAGGING_PROPERTY';
export const SET_OAT_PROPERTY_MODAL_OPEN = 'SET_OAT_PROPERTY_MODAL_OPEN';
export const SET_OAT_PROPERTY_MODAL_BODY = 'SET_OAT_PROPERTY_MODAL_BODY';
